// import triggerPopup from "../components/_trigger-popup";
import responsiveVideo from "../components/_responsive-video";

responsiveVideo();

/* ******************** TRIGGER POPUP ON PAGE LOAD ******************** */
// triggerPopup("#popup");
